module.exports = __webpack_public_path__ + "static/img/banner-RED&BLACK.d06a9b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/banner-RED&BLACK.jpg
// module id = zmfZ
// module chunks = 0